import UserLayout from '@/layouts/UserLayout.vue'

export const USER_ROUTES = [
  {
    path: 'user',
    component: UserLayout,
    redirect: { name: 'MembershipList' },
    children: [
      {
        path: 'memberships',
        name: 'MembershipList',
        component: () => import('./memberships/views/MembershipList.vue'),
      },
      {
        path: 'invites',
        name: 'InviteList',
        component: () => import('./invitations/views/InvitationList.vue'),
      },
    ],
  },
  {
    path: 'invites/create',
    name: 'CreateInvite',
    component: () => import('./invitations/views/CreateInvite.vue'),
  },
  {
    path: 'memberships/:id/edit',
    name: 'EditMembership',
    component: () => import('./memberships/views/EditMembership.vue'),
  },
  {
    path: 'organizations/edit',
    name: 'EditOrganization',
    component: () => import('./organizations/views/EditOrganization.vue'),
  },
]
